import e, { forwardRef as t, Fragment as r, cloneElement as n, createContext as o, useContext as a } from "react";
import { useWatch as s } from "react-hook-form";
export { useFieldArray, useForm as useFormState } from "react-hook-form";
import { get as i, TextInput as c, TextArea as u, useRadioState as l, RadioGroup as m, omit as d, NumberInput as f, Select as p, Checkbox as b, CheckboxGroup as h, useSwitchState as g, Switch as v } from "@vtex/admin-ui";
export { Radio } from "@vtex/admin-ui";
export { yupResolver } from "@hookform/resolvers/yup";

function x(e, t) {
  var r = {};

  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;

    for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) {
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
    }
  }

  return r;
}

"function" == typeof SuppressedError && SuppressedError;
var O = t(function (t, r) {
  var n = t.state,
      o = t.onSubmit,
      a = x(t, ["state", "onSubmit"]),
      s = n.handleSubmit;
  return e.createElement("form", Object.assign({
    ref: r,
    onSubmit: s(o)
  }, a));
});

function j(e) {
  var t = e.form,
      r = e.name,
      n = e.defaultValue,
      o = e.disabled;
  return s({
    control: t.control,
    name: r,
    defaultValue: n,
    disabled: o
  });
}

function E(t) {
  var n = t.children,
      o = j(x(t, ["children"]));
  return e.createElement(r, null, n ? n(o) : o);
}

function y(e, t) {
  return !!i(e, "formState.errors.".concat(t), !1);
}

function S(e, t) {
  return i(e, "formState.errors.".concat(t, ".message"));
}

function T(e) {
  k() && function (e) {
    e.name || w({
      text: "The name prop is required",
      tone: "error"
    });
    e.state || w({
      text: "The state prop is required",
      tone: "error"
    });
  }(e);
}

function k() {
  return "production" !== process.env.NODE_ENV;
}

function w(e) {
  switch (e.tone) {
    case "error":
      throw Error(e.text);

    case "warning":
      console.warn(e.text);
      break;

    case "neutral":
      console.log(e.text);
  }
}

function V(t) {
  var r = t.state,
      _t$name = t.name,
      n = _t$name === void 0 ? "" : _t$name,
      o = t.validation,
      a = x(t, ["state", "name", "validation"]),
      s = r.register;
  return T(t), e.createElement(c, Object.assign({
    error: y(r, n),
    errorText: S(r, n)
  }, s(n, o), a));
}

function N(t) {
  var r = t.state,
      _t$name2 = t.name,
      n = _t$name2 === void 0 ? "" : _t$name2,
      o = t.validation,
      a = x(t, ["state", "name", "validation"]),
      s = r.register;
  return T(t), e.createElement(u, Object.assign({
    error: y(r, n),
    errorText: S(r, n)
  }, s(n, o), a));
}

function C(t) {
  var r = t.state,
      _t$name3 = t.name,
      o = _t$name3 === void 0 ? "" : _t$name3,
      a = t.validation,
      s = t.children,
      i = x(t, ["state", "name", "validation", "children"]);
  T(t);
  var c = l({
    defaultValue: r.getValues(o)
  }),
      u = r.register(o, a);
  return e.createElement(m, Object.assign({
    state: c,
    error: y(r, o),
    errorText: S(r, o)
  }, i), e.Children.map(s, function (e) {
    return n(e, u);
  }));
}

function G(t) {
  var r = t.state,
      _t$name4 = t.name,
      n = _t$name4 === void 0 ? "" : _t$name4,
      o = t.validation,
      a = x(t, ["state", "name", "validation"]),
      s = r.register,
      i = r.setValue;
  T(t);
  var c = d(s(n, Object.assign(Object.assign({}, o), {
    setValueAs: function setValueAs(e) {
      return Number.isNaN(e) ? 0 : Number(e);
    }
  })), ["onChange"]);
  return e.createElement(f, Object.assign({
    error: y(r, n),
    errorText: S(r, n),
    onChange: function onChange(e) {
      return i(n, e);
    },
    value: r.getValues(n)
  }, c, a));
}

function A(t) {
  var r = t.state,
      _t$name5 = t.name,
      n = _t$name5 === void 0 ? "" : _t$name5,
      o = t.validation,
      a = x(t, ["state", "name", "validation"]),
      s = r.register;
  return T(t), e.createElement(p, Object.assign({
    error: y(r, n),
    errorText: S(r, n)
  }, s(n, o), a));
}

var P = o(null);
var Y = P.Provider;

function F(t) {
  var r = t.state,
      _t$name6 = t.name,
      n = _t$name6 === void 0 ? "" : _t$name6,
      o = t.validation,
      s = x(t, ["state", "name", "validation"]),
      i = a(P),
      c = !!i;

  if (k()) {
    c ? ((!!n || !!r || !!o) && w({
      tone: "error",
      text: "You are within a Group! The state, name, and validation props should be on the CheckboxGroup component"
    }), s.value || w({
      tone: "error",
      text: "You are within a Group! Add the `value` prop to each checkbox to give them meaning"
    })) : (n || w({
      tone: "error",
      text: "Your checkbox must have a name"
    }), r || w({
      tone: "error",
      text: "Your checkbox must have a state"
    }));
  }

  var u = c ? Object.assign({}, i.register) : Object.assign({
    error: y(r, n),
    errorText: S(r, n)
  }, null == r ? void 0 : r.register(n, o));
  return e.createElement(b, Object.assign({}, u, s));
}

function I(t) {
  var r = t.state,
      _t$name7 = t.name,
      n = _t$name7 === void 0 ? "" : _t$name7,
      o = t.validation,
      a = t.children,
      s = x(t, ["state", "name", "validation", "children"]);
  T(t);
  var i = r.register(n, o);
  return e.createElement(h, Object.assign({
    error: y(r, n),
    errorText: S(r, n)
  }, s), e.createElement(Y, {
    value: {
      register: i
    }
  }, a));
}

function R(t) {
  var r = t.state,
      _t$name8 = t.name,
      n = _t$name8 === void 0 ? "" : _t$name8,
      o = t.validation,
      a = x(t, ["state", "name", "validation"]),
      s = r.register,
      i = r.getValues,
      c = g({
    defaultValue: i(n)
  });
  return T(t), e.createElement(v, Object.assign({
    error: y(r, n),
    errorText: S(r, n),
    state: c
  }, s(n, o), a));
}

export { F as Checkbox, I as CheckboxGroup, O as Form, G as NumberInput, C as RadioGroup, A as Select, R as Switch, N as TextArea, V as TextInput, E as Watch, w as developerMessage, S as getErrorText, y as hasError, k as isDevMode, T as useFieldDx, j as useWatch };